import * as MobX from "mobx";
import { VariationStatusEnum } from "Views/Variation/Form/VariationModel";

export class VariationStatusTypeModel {
    constructor(dto: VariationStatusTypeDTO | null = null) {
        if (dto) {
            this.id = dto.id;
            this.ordinal = dto.ordinal;
            this.displayName = dto.displayName;
            this.type = dto.type;
            this.color = dto.color;
            this.textColor = dto.textColor;
        }
    }

    @MobX.observable
    public id: string = "";

    @MobX.observable
    public ordinal: number = 0;

    @MobX.observable
    public displayName: string = "Not defined";

    @MobX.observable
    public type: VariationStatusEnum = VariationStatusEnum.Draft;

    @MobX.observable
    public color: string = "#000000";

    @MobX.observable
    public textColor: string = "#FFFFFF";
}

export type VariationStatusTypeDTO = {
    id: string;
    ordinal: number;
    displayName: string;
    type: VariationStatusEnum;
    color: string;
    textColor: string;
};
